import { gql } from 'apollo-boost';

export const TERMS_QUERY = gql`
query terms {
    terms {
      edges {
        node {
          id
          name
          type
          description
          agreeText
          mustAgreeToTerm
          isAgreementCheckedByDefault
          isPublished
          localization 
        }
      }
    }
  }
`;